import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../environments/environment";

type GtagParams = Record<string, string | number | boolean>;

declare global {
    interface Window {
        dataLayer: unknown[];
        gtag: (...args: unknown[]) => void;
    }
}

@Injectable({
    providedIn: "root",
})
export class Analytics {
    private router = inject(Router);
    private initialized = false;

    initAnalytics(measurementId: string = environment.GA) {
        const gtag = window.gtag;
        if (!gtag) return;

        // this.router.events
        //     .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
        //     .subscribe((e) => {
        //         const pagePath = e.urlAfterRedirects;

        //         gtag("event", "page_view", {
        //             page_path: pagePath,
        //             page_location: window.location.href,
        //             page_title: document.title,
        //         });
        //     });
        this.initialized = true;
    }

    trackPageView(pagePath: string, title: string = document.title) {
        if (!this.initialized) {
            return;
        }

        const gtag = window.gtag;
        if (typeof gtag !== "function") {
            return;
        }

        gtag("event", "page_view", {
            page_path: pagePath,
            page_location: window.location.href,
            page_title: title,
        });
    }

    trackEvent(eventName: string, params: GtagParams) {
        if (typeof window === "undefined") {
            return;
        }

        const gtag = window.gtag;
        if (typeof gtag !== "function") {
            return;
        }

        gtag("event", eventName, params);
    }

    getHostDomainFromReferrer(): string | null {
        const referrer = document.referrer;
        if (!referrer) {
            return null;
        }

        try {
            return new URL(referrer).hostname;
        } catch {
            return null;
        }
    }
}
